<script>
import CompanyService from '@/services/company'
import ActivityService from '@/services/activity'
import CrmService from '@/services/crm'
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';

import moment from 'moment';
moment.locale('pt-BR');

export default {
  components: {  DatePicker },
  props: {
    customers: {
      type: Array,
      default: function() {
        return [];
      }
    },
    loadCustomers: {
      type: Function
    },
    action: {
      type: String,
      default: function() {
        return 'order';
      }
    }
  },
  methods: {
    details(customer) {
      this.customer = customer;
      this.showModal = true;
    },
    newOrder(customer) {
      this.customer = customer;
      this.showCompanyModal = true;
    },
    newActivity(customer) {
      this.customer = customer;
      this.activity = {
        type: 'phone',
        customer: customer._id,
        content: ''
      };
      this.showActivityModal = true;
    },
    newCrm(customer) {
      if (customer.hasCrmOpen) {
        return this.$toast.info('Esse cliente já possui um CRM aberto');
      }

      this.customer = customer;
      this.crm = {
        type: '',
        origin: '',
        customer: customer._id,
        content: '',
        reschedule: false,
        rescheduleDate: null,
      };
      this.showCrmModal = true;
    },
    selectCompany(companyId) {
      this.$store.dispatch('START_ORDER', { companyId, customerId: this.customer._id });
      this.showCompanyModal = false;

      this.$router.push('/products');
    },
    saveActivity() {
      if (!this.activity.content) {
        return this.$toast.info('Informe o conteúdo da atividade');
      }

      ActivityService.create(this.activity).then(() => {
        this.$toast.open('Atividade criada com sucesso');
        this.$router.push('/activities');
      }).catch(() => {
        this.$toast.error('Não foi possível criar a atividade. Tente novamente.')
      })
    },
    saveCrm() {
      if (!this.crm.type) {
        return this.$toast.info('Informe o tipo da interação');
      }

      if (!this.crm.origin) {
        return this.$toast.info('Informe a origem da interação');
      }

      if (!this.crm.content) {
        return this.$toast.info('Informe o conteúdo da interação');
      }

      if (this.crm.reschedule && !this.crm.rescheduleDate) {
        return this.$toast.info('Informe a data de reagendamento');
      }

      CrmService.create(this.crm).then(() => {
        this.$toast.open('Interação CRM criada com sucesso');
        
        this.showCrmModal = false;

        if (this.crm.reschedule) {
          this.$router.push('/crm-open');
        } else {
          this.$router.push('/crm-closed');
        }
      }).catch(() => {
        this.$toast.error('Não foi possível criar a interação. Tente novamente.')
      })
    },
    handleEnter() {
      return;
    },
    seeInvoiceData(item) {
      this.showInvoiceModal = true;
      this.invoiceData = item;
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY');
    },
    showPendencies(item) {
      this.showPendenciesModal = true;
      this.pendencies = item.customerPendencies;
      this.totalPendencies = item.totalPendencies;
    }
  },
  data() {
    return {
      customerToRemove: '',
      showModal: false,
      showCompanyModal: false,
      showActivityModal: false,
      showCrmModal: false,
      showInvoiceModal: false,
      showPendenciesModal: false,
      pendencies: [],
      totalPendencies: 0,
      customer: {},
      companies: [],
      activity: {},
      crm: {},

      fields: [
      ],

      invoiceData: {
        items: []
      },
      itemsInvoiceFields: [
        { key: 'sequence', sortable: true, label: 'Item' },
        { key: 'product.code', sortable: true, label: 'Código' },
        { key: 'product.description', sortable: true, label: 'Produto' },
        { key: 'quantity', sortable: true, label: 'Qtde.' },
        { key: 'price', sortable: true, label: 'Valor Unitário', formatter: (value, key, item) => {
          return (item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'total', sortable: true, label: 'Valor Total', formatter: (value, key, item) => {
          return (item.quantity * item.price).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } }
      ],

      pendenciesFields: [
        { key: 'companyName', sortable: true, label: 'Empresa' },
        { key: 'customerName', sortable: true, label: 'Cliente' },
        { key: 'invoiceNumber', sortable: true, label: 'NF', formatter: (value, key, item) => {
          return `${item.invoiceNumber}/${item.installment}`
        } },
        { key: 'invoiceSeries', sortable: true, label: 'Série' },
        { key: 'installment', sortable: true, label: 'Parcela' },
        { key: 'value', sortable: true, label: 'Valor Vencido', class: 'nowrap-col', formatter: (value) => {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }
        },
        { key: 'dueDate', sortable: true, label: 'Data Vencimento', formatter: (value) => {
            return moment(value).format('DD/MM/YYYY');
          }
        },
      ],
    };
  },
  mounted() {
    CompanyService.getAll().then((res) => {
      this.companies = res.data;
    })

    this.fields = [
      { key: 'code', sortable: true, label: 'Código' },
      { key: 'name', sortable: true, label: 'Razão Social' },
      { key: 'documentNumber', sortable: true, label: 'CNPJ' },
      { key: 'city', sortable: true, label: 'Cidade/UF', formatter: (value, key, item) => {
        return `${item.city}/${item.state}`;
      } },
    ]

    if (this.action === 'crm') {
      this.fields.push({ key: 'lastInvoice', sortable: true, label: 'Data Última NF', formatter: (value) => {
        if (value) return moment(value.date).format('DD/MM/YYYY');
        return '';
      } })
    }

    this.fields.push({ key: 'actions', label: 'Ações', class: 'nowrap-col' });
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
     <b-table
      show-empty
      emptyText="Nenhum registro para exibir"
      :items="customers"
      :fields="fields"
      responsive="sm"
      head-variant="light"
    >
      <template v-slot:cell(lastInvoice)="row">
        <div class="invoice-data" v-show="row.value">
          {{row.value}}
          <a href="javascript:void(0);" class="action-icon text-success ml-1" @click="seeInvoiceData(row.item.lastInvoice)">
            <i class="mdi mdi-eye font-size-18"></i>
          </a>
        </div>
      </template>

      <template v-slot:cell(name)="row">
        <span
          :class=" {
            'text-success': (row.item.hasCrm || (action !== 'crm' && row.item.customerType === 'C')),
            'text-danger': row.item.overdueCustomer,
          }"
        >{{row.item.name}}</span>
        <i v-if="row.item.hasB2bUser" v-b-tooltip.hover.top title="Cadastrado no B2B"  class="mdi mdi-account-check-outline text-primary font-size-18 ml-2"></i>
      </template>

      <template v-slot:cell(actions)="row">
        <b-button size="sm" variant="primary" class="mr-2" @click="newOrder(row.item)" v-if="action === 'order'">
          <i class="bx bx-plus font-size-16 align-middle"></i>
          Novo Pedido
        </b-button>

        <b-button size="sm" variant="primary" class="mr-2" @click="newActivity(row.item)" v-if="action === 'activity'">
          <i class="bx bx-plus font-size-16 align-middle"></i>
          Nova Atividade
        </b-button>

        <b-button size="sm" variant="primary" class="mr-2" @click="newCrm(row.item)" v-if="action === 'crm'">
          <i class="bx bx-plus font-size-16 align-middle"></i>
          Novo
        </b-button>

        <b-button size="sm" variant="outline-primary" @click="details(row.item)">Detalhes</b-button>

        <a
          href="javascript:void(0);"
          v-b-tooltip.hover.top
          title="Pendências Financeiras"
          class="action-icon text-danger"
          v-if="action === 'crm' && row.item.totalPendencies > 0"
          @click="showPendencies(row.item)"
        >
          <i class="mdi mdi-cash font-size-18 ml-2"></i>
        </a>
      </template>
    </b-table>

    <b-modal
      v-model="showCompanyModal"
      centered
      title="Selecionar Filial"
      hide-footer
    >
      <b-button
        v-for="company in companies"
        :key="company._id"
        size="lg"
        block
        variant="light"
        @click="selectCompany(company._id)"
      >
        {{company.code}} - {{company.name}}
      </b-button>
    </b-modal>

    <b-modal v-model="showModal" title="Detalhes do Cliente" centered>
      <div class="customer-detail">
        <div class="field">
          <p class="title">Código do Cliente:</p>
          <p>{{customer.code}}</p>
        </div>
        <div class="field">
          <p class="title">Fantasia:</p>
          <p>{{customer.companyName}}</p>
        </div>
        <div class="field">
          <p class="title">Razão Social:</p>
          <p>{{customer.name}}</p>
        </div>
        <div class="field">
          <p class="title">CPF/CNPJ:</p>
          <p>{{customer.documentNumber}}</p>
        </div>
        <div class="field">
          <p class="title">Endereço:</p>
          <p>{{customer.street}}</p>
        </div>
        <div class="field">
          <p class="title">Bairro:</p>
          <p>{{customer.district}}</p>
        </div>
        <div class="field">
          <p class="title">Cidade/UF:</p>
          <p>{{customer.city}}/{{customer.state}}</p>
        </div>
        <div class="field">
          <p class="title">CEP:</p>
          <p>{{customer.zipcode}}</p>
        </div>
        <div class="field">
          <p class="title">Telefone:</p>
          <p>{{customer.phoneNumber}}</p>
        </div>
        <div class="field">
          <p class="title">E-mail:</p>
          <p>{{customer.email}}</p>
        </div>
        <div class="field">
          <p class="title">Vendedor:</p>
          <p>{{customer.seller ? customer.seller.name : ''}}</p>
        </div>
        <div class="field">
          <p class="title">Valor Crédito:</p>
          <p>{{(customer.creditValue || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showModal = false">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showActivityModal"
      title="Nova Atividade"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form @submit.prevent="saveActivity">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name">Cliente</label>
              <input
                id="name"
                v-model="customer.name"
                type="text"
                class="form-control"
                disabled
              />
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Tipo</label>
              <select
                v-model="activity.type"
                class="form-control"
                name="activityType"
              >
                <option value="phone">Telefone</option>
                <option value="visit">Visita</option>
                <option value="email">E-mail</option>
                <option value="whatsapp">Whatsapp</option>
              </select>
            </div>
          </div>
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Conteúdo</label>
              <textarea
                v-model="activity.content"
                class="form-control"
                name="content"
                rows="3"
              ></textarea>
            </div>
          </div>          
        </div>

        <div class="text-right pt-5 mt-3">
          <b-button variant="link" @click="showActivityModal = false">Cancelar</b-button>
          <b-button type="submit" variant="primary" class="ml-2">Criar Atividade</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal
      v-model="showCrmModal"
      title="Nova Interação CRM"
      title-class="text-black font-18"
      body-class="p-3"
      hide-footer
    >
      <form @submit.prevent="saveCrm">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="name">Cliente</label>
              <input
                id="name"
                v-model="customer.name"
                type="text"
                class="form-control"
                disabled
              />
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="control-label">Grupo</label>
              <select
                v-model="crm.type"
                class="form-control"
                name="crmType"
              >
                <option value="bike">BIKE</option>
                <option value="mobilidade">MOBILIDADE</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="control-label">Tipo Atendimento</label>
              <select
                v-model="crm.attendance"
                class="form-control"
                name="attendance"
              >
                <option value="phone">Telefone</option>
                <option value="visit">Visita</option>
                <option value="email">E-mail</option>
                <option value="whatsapp">Whatsapp</option>
              </select>
            </div>
          </div>
          <div class="col-4">
            <div class="form-group">
              <label class="control-label">Origem</label>
              <select
                v-model="crm.origin"
                class="form-control"
                name="crmOrigin"
              >
                <option value="mob">MOB</option>
                <option value="app">APP</option>
                <option value="web">WEB</option>
              </select>
            </div>
          </div>

          <div class="col-12">
            <div class="form-group">
              <label class="control-label">Conteúdo</label>
              <textarea
                v-model="crm.content"
                class="form-control"
                name="content"
                rows="5"
                :maxlength="300"
                @keydown.enter.prevent="handleEnter"
              ></textarea>
              <div class="text-left">
                <p
                  v-if="crm.content"
                  class="badge position-absolute"
                  :class="{ 'badge-primary': crm.content.length !== 300,
                            'badge-danger': crm.content.length === 300 }"
                >
                  {{ crm.content.length }} /
                  300
                </p>
              </div>
            </div>
          </div>

          <div class="col col-6 mt-3">
            <div class="custom-control custom-checkbox mb-2">
              <input type="checkbox" class="custom-control-input" id="reschedule" v-model="crm.reschedule" />
              <label class="custom-control-label" for="reschedule">Reagendar?</label>
            </div>

            <date-picker
              v-if="crm.reschedule"
              v-model="crm.rescheduleDate"
              :first-day-of-week="1"
              format="DD/MM/YYYY"
              lang="pt-br"
            ></date-picker>
          </div>
        </div>

        <div class="text-right pt-4 mt-3">
          <b-button variant="link" @click="showCrmModal = false">Cancelar</b-button>
          <b-button type="submit" variant="primary" class="ml-2">Criar Interação</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal
      v-model="showInvoiceModal"
      body-class="p-3"
      size="lg"
      scrollable
    >
      <template v-slot:modal-header>
        <div class="header-invoice">
          <h5 class="modal-title text-black font-18">Detalhes da Nota Fiscal</h5>

          <div class="invoice-info mt-1">
            <p class="mb-0">Número NF: {{invoiceData.number}}-{{invoiceData.series}}</p>
            <p class="mb-0">Data: {{formatDate(invoiceData.date)}}</p>
            <p class="mb-0">Valor NF: {{invoiceData.totalValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}}</p>
          </div>
        </div>
      </template>

      <b-table
        bordered
        small
        :items="invoiceData.items"
        :fields="itemsInvoiceFields"
        responsive="sm"
      >
      </b-table>

      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showInvoiceModal = false">Fechar</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showPendenciesModal"
      body-class="p-3"
      size="lg"
      scrollable
      title="Pendências Financeiras"
    >
      <b-table
        show-empty
        emptyText="Nenhum registro para exibir"
        :items="pendencies"
        :fields="pendenciesFields"
        responsive="sm"
        head-variant="light"
      >
        <template slot="bottom-row">
          <td colspan="4"></td>
          <td class="text-left nowrap-col">
            <strong>Valor Total:</strong>
          </td>
          <td class="text-left nowrap-col">
            <h5 class="m-0">R$ {{totalPendencies | currency}}</h5>
          </td>
        </template>
      </b-table>

      <template v-slot:modal-footer>
        <b-button variant="primary" @click="showPendenciesModal = false">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .customer-detail {
    .field {
      display: flex;
      flex-direction: row;

      p {
        margin-bottom: 8px;

        &.title {
          font-weight: 600;
          color: #000;
          margin-right: 16px;
        }
      }
    }
  }

  .nowrap-col {
    white-space: nowrap;
  }

  .form-control:disabled {
    background-color: #e8e8e8 !important;
  }

  .invoice-data {
    white-space: nowrap;
  }

  .invoice-data a {
    line-height: 0px;
  }

  .header-invoice {
    display: grid;
  }

  .invoice-info p {
    font-size: 12px;
  }
</style>